export var MessageTypes;
(function (MessageTypes) {
    MessageTypes[MessageTypes["Welcome"] = 1] = "Welcome";
    MessageTypes[MessageTypes["Ack"] = 2] = "Ack";
    MessageTypes[MessageTypes["Heartbeat"] = 3] = "Heartbeat";
    MessageTypes[MessageTypes["Wakeup"] = 4] = "Wakeup";
    MessageTypes[MessageTypes["InstanceName"] = 5] = "InstanceName";
})(MessageTypes || (MessageTypes = {}));
;
